import { ApiErrorCatalog, ResolveApiErrorProps } from '../core/api-error';
import { Failure } from '../core/failure';

export enum SessionRepositoryFailureTypes {
  failToComunicateWithTheServer,
  missingVerifier,
}

export class SessionRepositoryFailure extends Failure<SessionRepositoryFailureTypes, void> {
  private constructor(errorMessage: string, errorType: SessionRepositoryFailureTypes) {
    super(errorMessage, errorType, undefined);
  }

  public static fromApiError(props: ResolveApiErrorProps) {
    return new SessionRepositoryFailure(
      ApiErrorCatalog.resolveMessage(props),
      SessionRepositoryFailureTypes.failToComunicateWithTheServer
    );
  }

  public static failToComunicateWithTheServer() {
    return new SessionRepositoryFailure(
      'Falha ao acessar dados',
      SessionRepositoryFailureTypes.failToComunicateWithTheServer
    );
  }

  public static missingVerifier() {
    return new SessionRepositoryFailure(
      'A sessão de login expirou. Tente novamente.',
      SessionRepositoryFailureTypes.missingVerifier
    );
  }
}
